const INVALIDS = {
  '<': ':lt:',
  '>': ':gt:',
  '/': ':sl:',
  '\\': ':bs:',
  '&': ':am:',
  '=': ':eq:',
  '?': ':qs:',
  ' ': ':sp:'
};

export const sanitize = ( text, maps = INVALIDS ) => {
  if ( !text || !text.indexOf ) {
    return '';
  }
  for ( let prop in maps ) {
    if ( !maps.hasOwnProperty( prop ) ) {
      continue;
    }
    text = text.split( prop ).join( maps[prop] );
  }
  return text;
}

export const desanitize = text => sanitize( text, Object.keys( INVALIDS ).reduce( 
  ( total, currentValue ) => {
    let prop = INVALIDS[currentValue];
    total[prop] = currentValue;

    return total;
  }, 
  { } 
) );

/**
 * @method convertToUnicode
 * @param {string} source the string that should have it's unicode characters replaced
 * @returns an empty string in case source is null or not a string otherwise the string with the unicode chars replaced
 */
export const convertToUnicode = source => source && source.replace ? source.replace( /&#(\d*);/g, ( a, b ) => String.fromCharCode( parseInt( b ) ) ) : '';